module.exports = {
    merchantName: "China Town",
    merchantDomain: "https://chinatownrestaurantbuckie.co.uk",  // Need correct! project will upload dist to targer domain file in Plesk.
    merchantMenuUrl: "/menu-china-town-restaurant-ab56", // target merchant's menu url in alleatapp.com
    // when you building files, fill this info, dont push these to github.
    pleskUsername: 'root',
    pleskPs: '3uyo$9!Ws9',
}
